import React, { Component } from 'react';

class HardwareFilterBox extends Component {
    render() {
        const { selected, onChange, totalDepots } = this.props;
        const options = [
            { value: "all", label: "All" },
            { value: "tracker", label: "Trackers" },
            { value: "dashcam", label: "Dashcams" },
        ];

        return (
            <div className="dashboard-filter-bar">
                <div className="dashboard-filter-heading">
                    <h2>Dashboard</h2>
                    <p>Live fleet, depot and alert overview</p>
                </div>
                <div className="dashboard-filter-title">
                    <div className="dashboard-filter-icon">
                        <i className="fa fa-sliders"></i>
                    </div>
                    <div>
                        <p>Hardware Type</p>
                        <strong>{options.find(option => option.value === selected)?.label || "All"}</strong>
                    </div>
                </div>
                <div className="hardware-filter-actions" role="group" aria-label="Hardware type filter">
                    {options.map(option => (
                        <button
                            className={selected === option.value ? "active" : ""}
                            key={option.value}
                            onClick={() => onChange(option.value)}
                            type="button"
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
                <div className="dashboard-filter-meta">
                    <span>{totalDepots || 0} depots</span>
                    <span>Updates fleet totals, depot rows and alert tables</span>
                </div>
            </div>
        );
    }
}

export default HardwareFilterBox;
